import { Guid } from "../util/guid";

export interface Toast {
  id: string;
  delay?: number;
  message?: string;
  title?: string;
  icon?: string | 'fa-exclamation-circle' | 'fa-info-circle';
  class?: 'success' | 'danger' | 'warning' | 'info' | 'primary'
}

export function toastFactory(obj: Partial<Toast>): Toast {
  return {
    id: obj.id || Guid.newGuid(),
    delay: obj.delay || 5000,
    message: obj.message,
    title: obj.title,
    class: obj.class || 'info',
    icon: obj.icon
  };
}
